import * as actionTypes from 'modules/auditModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isLoading = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [actionTypes.DELETE_AUDIT_MODEL]: isLoading,
  [actionTypes.DELETE_AUDIT_MODEL_SUCCESS]: isEnded,
  [actionTypes.DELETE_AUDIT_MODEL_FAILURE]: isEnded,

  [actionTypes.ACTIVATE_AUDIT_MODEL]: isLoading,
  [actionTypes.ACTIVATE_AUDIT_MODEL_SUCCESS]: isEnded,
  [actionTypes.ACTIVATE_AUDIT_MODEL_FAILURE]: isEnded,

  [actionTypes.DEACTIVATE_AUDIT_MODEL]: isLoading,
  [actionTypes.DEACTIVATE_AUDIT_MODEL_SUCCESS]: isEnded,
  [actionTypes.DEACTIVATE_AUDIT_MODEL_FAILURE]: isEnded,

  [actionTypes.PATCH_AUDIT_MODEL_STATUS]: isLoading,
  [actionTypes.PATCH_AUDIT_MODEL_STATUS_SUCCESS]: isEnded,
  [actionTypes.PATCH_AUDIT_MODEL_STATUS_FAILURE]: isEnded,
});
